import request from '@/utils/request'

let User_parksApi = {

  /*车位审核列表*/
  list(data) {
    return request._post('/shop/plus.user_parks.Index/index', data);
},
approve(data){
     return request._post('/shop/plus.user_parks.Index/approve', data);
},
/*添加车位审核*/
add(data) {
    return request._post('/shop/plus.user_parks.Index/add', data);
},
/*修改车位审核*/
edit(data) {
    return request._post('/shop/plus.user_parks.Index/edit', data);
},
/*删除车位审核*/
del(data) {
    return request._post('/shop/plus.user_parks.Index/del', data);
},
/*车位审核详情*/
detail(data) {
  return request._post('/shop/plus.user_parks.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.user_parks.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.user_parks.Setting/getSetting', data, errorback);
    },
}
export default User_parksApi;



// WEBPACK FOOTER //
// ./src/api/user_parks.js